export const filterSelector = (state) => state.leftMenu.filter
